import React from "react";
export var ShuffleIcon = function() {
    return /*#__PURE__*/ React.createElement("svg", {
        width: "29",
        height: "25",
        viewBox: "0 0 29 25",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("g", {
        className: "mix-blend-overlay group-hover:mix-blend-normal  group-active:mix-blend-normal transition-all duration-200 ease-in-out",
        opacity: 0.6
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M28 20.3846H17.9615C12.9077 20.3846 8.75385 4.46152 3.42308 4.46152H1",
        stroke: "white",
        className: "group-hover:stroke-green-600 group-active:stroke-green-600 transition-all duration-200 ease-in-out",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M24.5385 16.9231L28 20.3846L24.5385 23.7769M28 4.46152H17.9615C12.9077 4.46152 8.75385 20.3846 3.42308 20.3846H1",
        stroke: "white",
        className: "group-hover:stroke-green-600  group-active:stroke-green-600 transition-all duration-200 ease-in-out",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M24.5385 7.85385L28 4.46154L24.5385 1",
        stroke: "white",
        className: "group-hover:stroke-green-600  group-active:stroke-green-600 transition-all duration-200 ease-in-out",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })));
};
export var InfoIcon = function() {
    return /*#__PURE__*/ React.createElement("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("g", {
        className: "opacity-60 mix-blend-overlay group-hover:mix-blend-normal  group-active::mix-blend-normal group-hover:opacity-100 group-active:opacity-100 transition-all duration-200 ease-in-out"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.08333 12.5C2.08333 6.74687 6.74687 2.08333 12.5 2.08333C18.2531 2.08333 22.9167 6.74687 22.9167 12.5C22.9167 18.2531 18.2531 22.9167 12.5 22.9167C6.74687 22.9167 2.08333 18.2531 2.08333 12.5ZM12.5 0C5.59687 0 0 5.59687 0 12.5C0 19.4031 5.59687 25 12.5 25C19.4031 25 25 19.4031 25 12.5C25 5.59687 19.4031 0 12.5 0ZM11.4583 7.29167C11.4583 7.0154 11.5681 6.75045 11.7634 6.5551C11.9588 6.35975 12.2237 6.25 12.5 6.25C12.7763 6.25 13.0412 6.35975 13.2366 6.5551C13.4319 6.75045 13.5417 7.0154 13.5417 7.29167C13.5417 7.56793 13.4319 7.83289 13.2366 8.02824C13.0412 8.22359 12.7763 8.33333 12.5 8.33333C12.2237 8.33333 11.9588 8.22359 11.7634 8.02824C11.5681 7.83289 11.4583 7.56793 11.4583 7.29167ZM12.5 18.75C12.7763 18.75 13.0412 18.6403 13.2366 18.4449C13.4319 18.2496 13.5417 17.9846 13.5417 17.7083V11.4583C13.5417 11.1821 13.4319 10.9171 13.2366 10.7218C13.0412 10.5264 12.7763 10.4167 12.5 10.4167C12.2237 10.4167 11.9588 10.5264 11.7634 10.7218C11.5681 10.9171 11.4583 11.1821 11.4583 11.4583V17.7083C11.4583 17.9846 11.5681 18.2496 11.7634 18.4449C11.9588 18.6403 12.2237 18.75 12.5 18.75Z",
        fill: "white",
        className: "group-hover:fill-green-600 group-active:fill-green-600 transition-all duration-200 ease-in-out"
    })));
};
export var InfoIconWithCircle = function() {
    return /*#__PURE__*/ React.createElement("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("g", {
        className: "opacity-60 mix-blend-overlay group-hover:mix-blend-normal  group-active:mix-blend-normal group-hover:opacity-100 group-active:opacity-100 transition-all duration-200 ease-in-out",
        opacity: "0.6"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.5 15C2.5 8.09625 8.09625 2.5 15 2.5C21.9037 2.5 27.5 8.09625 27.5 15C27.5 21.9037 21.9037 27.5 15 27.5C8.09625 27.5 2.5 21.9037 2.5 15ZM15 0C6.71625 0 0 6.71625 0 15C0 23.2838 6.71625 30 15 30C23.2838 30 30 23.2838 30 15C30 6.71625 23.2838 0 15 0ZM13.75 8.75C13.75 8.41848 13.8817 8.10054 14.1161 7.86612C14.3505 7.6317 14.6685 7.5 15 7.5C15.3315 7.5 15.6495 7.6317 15.8839 7.86612C16.1183 8.10054 16.25 8.41848 16.25 8.75C16.25 9.08152 16.1183 9.39946 15.8839 9.63388C15.6495 9.8683 15.3315 10 15 10C14.6685 10 14.3505 9.8683 14.1161 9.63388C13.8817 9.39946 13.75 9.08152 13.75 8.75ZM15 22.5C15.3315 22.5 15.6495 22.3683 15.8839 22.1339C16.1183 21.8995 16.25 21.5815 16.25 21.25V13.75C16.25 13.4185 16.1183 13.1005 15.8839 12.8661C15.6495 12.6317 15.3315 12.5 15 12.5C14.6685 12.5 14.3505 12.6317 14.1161 12.8661C13.8817 13.1005 13.75 13.4185 13.75 13.75V21.25C13.75 21.5815 13.8817 21.8995 14.1161 22.1339C14.3505 22.3683 14.6685 22.5 15 22.5Z",
        fill: "white"
    })));
};
export var ArrowCircleRightIcon = function() {
    return /*#__PURE__*/ React.createElement("svg", {
        width: 87,
        height: 87,
        viewBox: "0 0 87 87",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("g", {
        className: "mix-blend-overlay group-hover:mix-blend-normal  group-active:mix-blend-normal group-hover:opacity-100 group-active:opacity-100 transition-all duration-200 ease-in-out",
        opacity: 0.3
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 43.5,
        cy: 43.5,
        r: 43.5,
        fill: "white"
    })), /*#__PURE__*/ React.createElement("path", {
        d: "M37.5273 56.9452L50.4725 44L37.5273 31.0548",
        stroke: "white",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "group-hover:stroke-green-600 group-active:stroke-green-600 transition-all duration-200 ease-in-out"
    }));
};
export var ArrowCircleLeftIcon = function() {
    return /*#__PURE__*/ React.createElement("svg", {
        width: 87,
        height: 87,
        viewBox: "0 0 87 87",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("g", {
        className: "mix-blend-overlay group-hover:mix-blend-normal  group-active:mix-blend-normal group-hover:opacity-100 group-active:opacity-100 transition-all duration-200 ease-in-out",
        opacity: 0.3
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 43.5,
        cy: 43.5,
        r: 43.5,
        transform: "rotate(-180 43.5 43.5)",
        fill: "white"
    })), /*#__PURE__*/ React.createElement("path", {
        d: "M49.4727 30.0548L36.5274 43L49.4727 55.9452",
        stroke: "white",
        className: "group-hover:stroke-green-600 group-active:stroke-green-600 transition-all duration-200 ease-in-out",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
export var ShareIcon = function() {
    return /*#__PURE__*/ React.createElement("svg", {
        width: "29",
        height: "29",
        viewBox: "0 0 29 29",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("g", {
        className: "mix-blend-overlay group-hover:mix-blend-normal  group-active:mix-blend-normal group-hover:opacity-100 group-active:opacity-100 transition-all duration-200 ease-in-out",
        opacity: "0.6"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M23.2019 17.4187C22.3455 17.4243 21.5009 17.6194 20.729 17.9898C19.9571 18.3603 19.2769 18.8969 18.7373 19.5612L11.3447 16.1592C11.6923 15.0963 11.6923 13.9504 11.3447 12.8875L18.7373 9.48549C19.6094 10.5364 20.8252 11.246 22.17 11.4888C23.5149 11.7317 24.9025 11.4923 26.0878 10.8129C27.2732 10.1334 28.1801 9.05768 28.6486 7.77544C29.117 6.4932 29.1169 5.0869 28.6482 3.80475C28.1795 2.52259 27.2724 1.447 26.0869 0.767791C24.9014 0.0885856 23.5138 -0.150568 22.169 0.0925381C20.8242 0.335644 19.6085 1.04538 18.7367 2.09649C17.8648 3.1476 17.3927 4.47251 17.4038 5.83739C17.4081 6.18227 17.4421 6.52614 17.5052 6.86523L9.85172 10.383C9.03575 9.58622 8.00248 9.0476 6.88135 8.83467C5.76023 8.62173 4.60112 8.74396 3.54924 9.18602C2.49736 9.62808 1.5995 10.3703 0.968137 11.3198C0.336777 12.2692 0 13.3836 0 14.5233C0 15.6631 0.336777 16.7775 0.968137 17.7269C1.5995 18.6764 2.49736 19.4186 3.54924 19.8607C4.60112 20.3027 5.76023 20.425 6.88135 20.212C8.00248 19.9991 9.03575 19.4605 9.85172 18.6637L17.5052 22.1815C17.4421 22.5206 17.4081 22.8644 17.4038 23.2093C17.4038 24.3546 17.7438 25.4741 18.3809 26.4264C19.018 27.3787 19.9236 28.1209 20.983 28.5592C22.0425 28.9974 23.2083 29.1121 24.333 28.8887C25.4578 28.6652 26.4909 28.1137 27.3018 27.3039C28.1126 26.4941 28.6649 25.4623 28.8886 24.339C29.1123 23.2157 28.9975 22.0514 28.5586 20.9933C28.1198 19.9352 27.3766 19.0308 26.4231 18.3946C25.4696 17.7583 24.3486 17.4187 23.2019 17.4187ZM23.2019 2.94208C23.7753 2.94208 24.3358 3.11188 24.8125 3.43003C25.2893 3.74817 25.6608 4.20035 25.8803 4.7294C26.0997 5.25845 26.1571 5.8406 26.0452 6.40224C25.9334 6.96388 25.6573 7.47977 25.2518 7.88469C24.8464 8.28961 24.3298 8.56536 23.7675 8.67708C23.2051 8.78879 22.6222 8.73146 22.0925 8.51232C21.5627 8.29318 21.11 7.92208 20.7914 7.44595C20.4729 6.96981 20.3028 6.41003 20.3028 5.83739C20.3028 5.06951 20.6083 4.33307 21.1519 3.79009C21.6956 3.24712 22.433 2.94208 23.2019 2.94208ZM5.80753 17.4187C5.23415 17.4187 4.67365 17.2489 4.1969 16.9307C3.72016 16.6126 3.34858 16.1604 3.12915 15.6313C2.90973 15.1023 2.85232 14.5201 2.96418 13.9585C3.07604 13.3969 3.35215 12.881 3.75759 12.476C4.16303 12.0711 4.67959 11.7954 5.24196 11.6837C5.80432 11.5719 6.38722 11.6293 6.91696 11.8484C7.44669 12.0676 7.89946 12.4387 8.21801 12.9148C8.53656 13.3909 8.70659 13.9507 8.70659 14.5233C8.70659 15.2912 8.40116 16.0277 7.85748 16.5706C7.3138 17.1136 6.57641 17.4187 5.80753 17.4187ZM23.2019 26.1046C22.6285 26.1046 22.068 25.9348 21.5912 25.6167C21.1145 25.2985 20.7429 24.8463 20.5235 24.3173C20.3041 23.7882 20.2467 23.2061 20.3585 22.6445C20.4704 22.0828 20.7465 21.5669 21.1519 21.162C21.5574 20.7571 22.0739 20.4813 22.6363 20.3696C23.1987 20.2579 23.7816 20.3152 24.3113 20.5344C24.841 20.7535 25.2938 21.1246 25.6124 21.6007C25.9309 22.0769 26.1009 22.6367 26.1009 23.2093C26.1009 23.9772 25.7955 24.7136 25.2518 25.2566C24.7081 25.7996 23.9708 26.1046 23.2019 26.1046Z",
        fill: "white"
    })));
};
export var MailIcon = function() {
    return /*#__PURE__*/ React.createElement("svg", {
        width: "28",
        height: "22",
        viewBox: "0 0 28 22",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("g", {
        className: "mix-blend-overlay group-hover:mix-blend-normal  group-active:mix-blend-normal group-hover:opacity-100 group-active:opacity-100 transition-all duration-200 ease-in-out ",
        opacity: "0.6"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M3.58824 1.99994H24.7647C25.6118 1.99994 26.3529 2.74112 26.3529 3.58817V18.4117C26.3529 19.2588 25.6118 19.9999 24.7647 19.9999H3.58824C2.74118 19.9999 2 19.2588 2 18.4117V3.58817C2 2.74112 2.74118 1.99994 3.58824 1.99994Z",
        stroke: "white",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M2.42354 2.42349C2.42354 2.42349 10.4706 9.83526 13.0118 12.0588C13.6471 12.6941 14.6 12.6941 15.2353 12.0588C17.7765 9.83526 25.8235 2.42349 25.8235 2.42349M25.9294 19.5764C25.9294 19.5764 19.8941 13.7529 16.6118 11M11.7412 11C8.45883 13.7529 2.42354 19.5764 2.42354 19.5764",
        stroke: "white",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })));
};
export var ArrowHalfCircleLeftIcon = function() {
    return /*#__PURE__*/ React.createElement("svg", {
        width: "49",
        height: "84",
        viewBox: "0 0 49 84",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("g", {
        className: "mix-blend-overlay group-active:mix-blend-normal group-hover:mix-blend-normal   group-active:opacity-100 group-hover:opacity-100  transition-all duration-200 ease-in-out",
        opacity: "0.3"
    }, /*#__PURE__*/ React.createElement("ellipse", {
        cx: "7.5",
        cy: "41.9998",
        rx: "41.5",
        ry: "42",
        transform: "rotate(-180 7.5 41.9998)",
        fill: "white"
    })), /*#__PURE__*/ React.createElement("path", {
        d: "M22.7546 28.2756L9.58624 41.444L22.7546 54.6124",
        stroke: "white",
        className: "group-active:stroke-green-600 group-hover:stroke-green-600 transition-all duration-200 ease-in-out",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
export var ArrowHalfCircleRightIcon = function() {
    return /*#__PURE__*/ React.createElement("svg", {
        width: "50",
        height: "84",
        viewBox: "0 0 50 84",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("g", {
        className: "mix-blend-overlay group-hover:mix-blend-normal  group-active:mix-blend-normal group-hover:opacity-100 group-active:opacity-100 transition-all duration-200 ease-in-out",
        opacity: "0.3"
    }, /*#__PURE__*/ React.createElement("ellipse", {
        cx: "41.5",
        cy: "42",
        rx: "41.5",
        ry: "42",
        transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 0 84)",
        fill: "white"
    })), /*#__PURE__*/ React.createElement("path", {
        d: "M26.2454 28.2758L39.4138 41.4442L26.2454 54.6126",
        stroke: "white",
        className: "group-hover:stroke-green-600 group-active:stroke-green-600 transition-all duration-200 ease-in-out",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
export var CopyIcon = function() {
    return /*#__PURE__*/ React.createElement("span", {
        className: "h-12 w-12 rounded-full bg-grey-700 flex items-center justify-center text-white transition hover:opacity-75 active:opacity-75"
    }, /*#__PURE__*/ React.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M10.8732 13.6998L9.4842 15.0888C8.183 16.39 6.07398 16.39 4.77278 15.0888C3.47157 13.7876 3.47157 11.6786 4.77278 10.3774L5.9326 9.26489",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeMiterlimit: "10",
        strokeLinecap: "square",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M9.125 6.30026L10.514 4.91127C11.8152 3.61006 13.9242 3.61006 15.2254 4.91127C16.5266 6.21247 16.5266 8.32149 15.2254 9.62269L14.0656 10.7352",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeMiterlimit: "10",
        strokeLinecap: "square",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "7.55852",
        y1: "12.5141",
        x2: "12.5142",
        y2: "7.55839",
        stroke: "currentColor",
        strokeWidth: "2"
    })));
};
export var ExternalLinkIcon = function() {
    return /*#__PURE__*/ React.createElement("svg", {
        width: "20",
        height: "18",
        viewBox: "0 0 20 18",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M6.9477 12.527C7.05285 12.6404 7.19884 12.7072 7.35354 12.7127C7.50825 12.7183 7.65899 12.6622 7.77262 12.5567L16.1636 4.76972L16.0266 8.30992C16.0234 8.46292 16.0804 8.61092 16.1853 8.72204C16.2902 8.83316 16.4347 8.89851 16.5877 8.90401C16.7406 8.90952 16.8898 8.85473 17.003 8.75146C17.1163 8.64819 17.1845 8.5047 17.1931 8.35188L17.3846 3.40286C17.3878 3.32677 17.3759 3.25084 17.3496 3.17944C17.3233 3.10805 17.2831 3.04259 17.2314 2.98684L17.2298 2.98513C17.1782 2.92958 17.1155 2.88438 17.0449 2.85293C16.9755 2.82094 16.9003 2.80308 16.8239 2.80037L11.8744 2.62232C11.7213 2.61947 11.5731 2.67684 11.4617 2.78205C11.3503 2.88727 11.2845 3.03192 11.2786 3.18485C11.2727 3.33779 11.3271 3.48676 11.4301 3.59969C11.5331 3.71262 11.6764 3.78047 11.8292 3.78863L15.3706 3.91521L6.97961 11.7022C6.86599 11.8077 6.79879 11.9538 6.79281 12.1085C6.78682 12.2632 6.84254 12.4137 6.9477 12.527Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M9.89688 5.08392H1V16.5228H12.4388V10.8033",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
export var WhiteCloseIcon = function() {
    return /*#__PURE__*/ React.createElement("svg", {
        width: "38",
        height: "38",
        viewBox: "0 0 38 38",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M37.6523 35.9723L20.679 18.9927L37.6523 2.01317C38.0969 1.5529 38.0969 0.823044 37.6523 0.362624C37.1967 -0.109251 36.4449 -0.122303 35.9732 0.333477L19 17.313L2.02684 0.333622C1.56673 -0.110991 0.837146 -0.110991 0.376897 0.333622C-0.0948043 0.789401 -0.10785 1.54144 0.34776 2.01332L17.3209 18.9927L0.34776 35.9721C0.125101 36.1949 2.96961e-08 36.4969 2.96961e-08 36.8119C-0.000145085 37.4679 0.53157 37.9999 1.18737 38C1.50237 38.0003 1.80447 37.875 2.02684 37.6518L19 20.6724L35.9732 37.652C36.1956 37.8751 36.4978 38.0004 36.8128 38C37.1275 37.9999 37.4293 37.8749 37.652 37.6523C38.1159 37.1884 38.116 36.4362 37.6523 35.9723Z",
        fill: "white"
    }));
};
export var ArrowRightIcon = function() {
    return /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "11",
        viewBox: "0 0 18 11",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0 5.5C0 5.70878 0.0790178 5.90901 0.21967 6.05664C0.360322 6.20427 0.551088 6.28721 0.75 6.28721H15.4395L12.2205 9.66591C12.0839 9.81438 12.0083 10.0132 12.01 10.2196C12.0117 10.426 12.0906 10.6235 12.2296 10.7694C12.3687 10.9154 12.5568 10.9982 12.7534 11C12.9501 11.0018 13.1395 10.9224 13.281 10.779L17.781 6.05577C17.8504 5.98335 17.9055 5.89724 17.9431 5.80241C17.9806 5.70757 18 5.60587 18 5.50315V5.5C18 5.39766 17.9805 5.29533 17.9415 5.19929C17.9041 5.10385 17.8491 5.01715 17.7795 4.94423L13.2795 0.220979C13.138 0.0775823 12.9486 -0.00176383 12.7519 2.97586e-05C12.5553 0.00182335 12.3672 0.0846131 12.2281 0.230568C12.0891 0.376523 12.0102 0.573965 12.0085 0.780368C12.0068 0.986772 12.0824 1.18562 12.219 1.33409L15.4395 4.71279H0.75C0.551088 4.71279 0.360322 4.79573 0.21967 4.94336C0.0790178 5.09099 0 5.29122 0 5.5Z",
        fill: "white"
    }));
};
